<template>
    <DnButton
        class="base-button"
    >
        <slot />
    </DnButton>
</template>

<script setup>
import DnButton from '@digitalnatives/button';
</script>

<style src="./BaseButton.less" lang="less"></style>
